export default "__VITE_ASSET__812ee2c5__"